// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import VueMaterial from 'vue-material'
import VueI18n from 'vue-i18n'
import Vue2TouchEvents from 'vue2-touch-events'
import messages from './translation'
import 'vue-material/dist/vue-material.css'
// import 'vue-material/dist/theme/default.css'
import './assets/style/style.css'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'leaflet/dist/leaflet.css'
import { BTabs, BTab, BProgress, BProgressBar } from 'bootstrap-vue'
import { Icon } from 'leaflet'

// this part resolve an issue where the markers would not appear
delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
})

Vue.use(VueMaterial)
Vue.use(VueI18n)
Vue.use(Vue2TouchEvents)
Vue.component('b-tabs', BTabs)
Vue.component('b-tab', BTab)
Vue.component('b-progress', BProgress)
Vue.component('b-progress-bar', BProgressBar)

Vue.config.productionTip = false
if (localStorage.lang === undefined) {
  localStorage.lang = 'en'
}
export const i18n = new VueI18n({
  locale: localStorage.lang,
  messages
})

Vue.prototype.$edit = 'EDIT'
Vue.prototype.$new = 'NEW'

App.i18n = i18n
App.router = router
App.store = store
new Vue({
  'render': h => h(App)
}).$mount('#app')
